import { Link, useNavigate } from "react-router-dom";
import { scrollToJoinSection } from "@/lib/scroll-to-join";

export default function Navbar() {
  const navigate = useNavigate();

  function goToJoinForm() {
    if (scrollToJoinSection()) return;
    void navigate("/#join");
  }

  return (
    <nav aria-label="Main navigation" className="sticky top-0 z-[60] animate-[fade-in_0.4s_ease-out]">
      <div className="max-w-2xl mx-auto px-3 sm:px-4 pt-3">
        <div className="bg-black/80 backdrop-blur-md border border-white/30 rounded-2xl px-4 sm:px-6 h-12 sm:h-14 flex items-center justify-between">
          {/* Brand */}
          <Link
            to="/"
            onClick={(e) => {
              e.preventDefault();
              goToJoinForm();
            }}
            className="font-fira text-base sm:text-lg font-bold text-white whitespace-nowrap shrink-0 cursor-pointer"
          >
            Staying Ahead
          </Link>

          <div className="flex items-center gap-2 sm:gap-3">
            {/* <Link
              to="/nl"
              className="text-secondary hover:text-white text-sm transition-colors whitespace-nowrap"
            >
              Newsletter
            </Link> */}
            <button
              type="button"
              onClick={() => goToJoinForm()}
              className="bg-white text-black rounded-full px-4 sm:px-5 py-1.5 text-xs sm:text-sm font-semibold hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer"
            >
              Join Community &rarr;
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
